/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useEvent, useMedia } from '@api/hooks';
import { InfoItem } from '@molecules';
import { getImage } from '@utils/media';

const Item = ({ className, module, errors }) => {
  const { event } = useEvent(module.content.eventId);
  const { media } = useMedia(getImage(module.content));

  let description = `${module.content.topTitle} ${module.content.bottomTitle}`;

  if (module.content.eventId) {
    description = event.name || 'loading event title...';
  }

  return (
    <InfoItem.WithError error={errors} className={className} size="large" image={media.src} description={description}>
      Next Event
    </InfoItem.WithError>
  );
};

export default Item;
